import { getRuntimeEnvironment } from '../getRuntimeEnvironment';

const PRODUCTION_ORG_ID = '8u0q6ob5';
const SANDBOX_ORG_ID = 'apya3fbi';

type ThreatMetrixConfig = {
  orgId: string;
  pageId: number;
  profilingHost: string;
  toolkitUrl: string;
};

export const getThreatMetrixConfig = (): ThreatMetrixConfig => ({
  orgId:
    getRuntimeEnvironment() === 'PRODUCTION'
      ? PRODUCTION_ORG_ID
      : SANDBOX_ORG_ID,
  pageId: 3,
  profilingHost: 'h.online-metrix.net',
  // v6.0 of the ThreatMetrix profiling toolkit.
  toolkitUrl:
    'https://static.iwoca.com/js/e142ec0e-8add-498b-925c-43bf3f9012e4.js',
});
